import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";

class DetailAllDispositionen extends Component {
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            {this.props.allDispositionen.length > 1 && (
              <div className="row detail-space-top-element">
                <div className="hslu-link detail-list-of-dispositionen">
                  <ul className="span8">
                    {this.props.allDispositionen.map(
                      ({ id, massnahme, datum }) => (
                        <li key={id}>
                          <NavLink
                            to={`/detail/${id}`}
                            activeClassName="active-link"
                          >
                            {massnahme} {datum}
                          </NavLink>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
        )}
      </I18n>
    );
  }
}

export default withRouter(DetailAllDispositionen);



// WEBPACK FOOTER //
// ./src/detail/DetailAllDispositionen.js